import img1 from "../src/img/Tandoori..jpg";
import img2 from "../src/img/kadai..jpg";
import img3 from "../src/img/chilli..jpg";
import img4 from "../src/img/Chicken korma.jpg";
import img5 from "../src/img/butter. chicken.webp";
import img6 from "../src/img/keema chicken.jpg";
import img7 from "../src/img/Chicken-Tikka-Masala.webp";
import img8 from "../src/img/irani. Chicken.jpg";
import img9 from "../src/img/malvani Chicekn.jpg";
import img10 from "../src/img/kolhapuri Chicken.webp";
import img11 from "../src/img/amritsari. Chicken.webp";


const Chickendata ={
    cardData : [
  
             {
                id: 1,
                imgSrc:img1 ,
                title: 'Tandoori Chicken.',
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                 link : './Briyani',
                 rs : '380'
             },
             {
                 id: 2,
                 imgSrc:img2 ,
                 title: 'Kaadi Chicken',
                 cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                 rs : '120'
              } ,
              {
                 id: 3,
                 imgSrc:img3 ,
                 title: 'Chilli Chicken',
                 cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                 rs : '150'
               } ,
              {
                 id: 4,
                 imgSrc:img4,
                 title: 'Chicken Korma',
                 cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                 rs : '140'
              },
              {
                id: 5,
                imgSrc:img5 ,
                title: 'Butter Chicken',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '220'
             },
             {
                id: 6,
                imgSrc:img6 ,
                title: 'Chicken Keema',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '220'
             },
             {
                id: 7,
                imgSrc:img7 ,
                title: 'Chicken Tikka Masala',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '240'
             },
             {
                id: 8,
                imgSrc:img8 ,
                title: 'Irani Chicken Kadhai',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '320'
             },
             {
                id: 9,
                imgSrc:img9 ,
                title: 'Spicy Malvani Chicken Curry',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '280'
             },
             {
                id: 10,
                imgSrc:img10 ,
                title: 'Kolhapuri Chicken',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '190'
             },
                {
                id: 11,
                imgSrc:img11,
                title: 'Amritsari Chicken',  
                cont : 'Tandoori Chicken ,Kaadi Chicken, Chilli Chicken,Chicken Korma ,Butter Chicken,Chicken Keema,',
                rs : '160'
             },
          
          
          
     ]
 };
 
 export default Chickendata;